import { createI18n } from 'vue-i18n'
import store from "@/store"
import en_us from '@/locales/en_us'
import zh_tw from '@/locales/zh_tw'
import zh_cn from '@/locales/zh_cn'

export default createI18n({
  legacy: false,
  globalInjection: true,
  locale: ["ZH_TW", "EN_US", "ZH_CN"].includes(store.state.language) ? store.state.language : "EN_US",
  fallbackLocale: "EN_US",
  messages: {
     "ZH_TW": zh_tw,
     "EN_US": en_us,
     "ZH_CN": zh_cn,
  }
});
